import { FLEET_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminFleetService = {
  getAll: (params: any) => requests.get(`${FLEET_URL}`, params),
  create: (params: any) => requests.post(`${FLEET_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${FLEET_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${FLEET_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${FLEET_URL}/${id}`),
};
